import { render, staticRenderFns } from "./SetupUsage.vue?vue&type=template&id=1e617815&scoped=true"
import script from "./SetupUsage.vue?vue&type=script&lang=js"
export * from "./SetupUsage.vue?vue&type=script&lang=js"
import style0 from "./SetupUsage.vue?vue&type=style&index=0&id=1e617815&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e617815",
  null
  
)

export default component.exports